import { useEffect, useMemo, useState } from 'react';
import RecipeCard from './Recipe-card';
import { fetchAllRecipes } from './api';
import Heading1 from './headings/Heading1';

function RelatedRecipes({ currentId, cuisine }) {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllRecipes()
      .then((all) => setRecipes(all || []))
      .finally(() => setLoading(false));
  }, []);

  const related = useMemo(() => {
    const pool = recipes.filter((r) => r.id !== currentId);
    const cuisineMatches = cuisine
      ? pool.filter((r) => r.cuisine && r.cuisine === cuisine)
      : [];

    if (cuisineMatches.length >= 3) {
      return cuisineMatches.slice(0, 3);
    }

    const byProtein = pool.filter((r) => r.highProtein);
    const fallback = [...cuisineMatches, ...byProtein, ...pool];

    const unique = [];
    const seen = new Set();
    for (const item of fallback) {
      if (!seen.has(item.id)) {
        unique.push(item);
        seen.add(item.id);
      }
      if (unique.length === 3) break;
    }

    return unique;
  }, [recipes, currentId, cuisine]);

  if (loading || related.length === 0) return null;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Heading1 title="You also may like" />
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {related.map((recipe) => (
          <RecipeCard key={recipe.id} recipe={recipe} showCTA />
        ))}
      </div>
    </div>
  );
}

export default RelatedRecipes;
